<template>
  <div class="app-main-content">
    <div>
      <h1 v-if="store.state.guestLogin.mfaStep != 6">Multi Factor Authentication (MFA)</h1>
      <h1 v-else>Online Services</h1>
      <div><SystemAlert/></div>
      <ContactDetails v-if="store.state.guestLogin.mfaStep == 1" />
      <Otp v-if="store.state.guestLogin.mfaStep == 2" />
      <OtherDetails v-if="store.state.guestLogin.mfaStep == 3" />
      <!-- User enters DD option is removed per business requirement -->
      <OtpByMail v-if="store.state.guestLogin.mfaStep == 5" />
      <OnlineServicesLinks v-if="store.state.guestLogin.mfaStep == 6" />
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import ContactDetails from '../../components/multiFactorAuth/ContactDetails.vue';
import Otp from '../../components/multiFactorAuth/Otp.vue';
import OtherDetails from '../../components/multiFactorAuth/OtherDetails.vue';
import OtpByMail from '../../components/multiFactorAuth/OtpByMail.vue';
import SystemAlert from '@/components/SystemAlert';
import appConfig from '@/app.config';
import { useHead } from '@unhead/vue'
import OnlineServicesLinks from '../../components/multiFactorAuth/OnlineServiceLinks.vue';
import { watch, onMounted } from 'vue';
    import { useRoute, useRouter } from 'vue-router';

// Vuex store
const store = useStore();
const route = useRoute();
const router = useRouter();

// unhead to manage the page meta
useHead({
  title: `Multi Factor Authentication | ${appConfig.shortName}`,
  meta: [
    {
      name: 'description',
      content: appConfig.description
    }
  ]
});

onMounted(() => {
  if (!route.query.step) {
    router.replace({ name: 'MultiFactAuth', query: { step: String(store.state.guestLogin.mfaStep) } });
  }
});

watch(() => route.query.step, (newStep) => {
  if (newStep !== undefined) {
    const stepNum = Number(newStep);
    if (stepNum && stepNum !== store.state.guestLogin.mfaStep) {
      store.commit('guestLogin/setState', { property: 'mfaStep', value: stepNum });
    }
  }
});

watch(() => store.state.guestLogin.mfaStep, (newStep) => {
  const urlStep = route.query.step ? Number(route.query.step) : null;
  if (newStep !== urlStep) {
    router.push({ name: 'MultiFactAuth', query: { step: String(newStep) } }).catch(() => {});
  }
});
</script>